import Layout from "./Layout";
import React, { useEffect, useState } from "react";
import DataTableList from "../component/DataTableList";
import { opList } from "../api/network/api";
import ActionButton from "../component/ActionButtons";
function UserList() {
  const [userData, setUserData] = useState([]);
  const [searchedData, setSearchedData] = useState([]);
  const [searchBox, setSearchBox] = useState({
    name: "",
    mobile: "",
    verified: "",
  });
  const [showSpinner, setShowSpinner] = useState(false);

  const columns = [
    {
      name: "Name",
      selector: (row) => row.name,
    },
    {
      name: "Photo",
      selector: (row) => (
        <img
          className="mt-1"
          src={row.photo}
          style={{
            height: "60px",
            width: "60px",
            border: "1px solid #5e2b97",
            borderRadius: "50%",
          }}
        />
      ),
      sortable: false,
    },
    {
      name: "MSN",
      selector: (row) => row.mobile,
      maxWidth: 400,
      minWidth: 140,
    },
    {
      name: "Verify",
      selector: (row) => row.verify,
    },
    {
      name: "Action",
      selector: (row) => (
        <ActionButton edit view actionTo="user" id={row.user_id} />
      ),
    },
  ];

  useEffect(() => {
    setShowSpinner(true);

    opList("get", "user")
      .then((result) => {
        // console.log("result:>>>>>>>>", result.data);
        setUserData(result.data);
        setSearchedData(result.data);
      })
      .catch((error) => {
        console.log(error, "errorrrrrrrrrrrrrrrrrrrrrrrr:>>>>>>>>>>");
      })
      .finally(() => {
        setShowSpinner(false);
      });
  }, []);

  useEffect(() => {
    if (
      searchBox?.name == "" &&
      searchBox.mobile == "" &&
      searchBox.verified == ""
    ) {
      console.log("coming");
      setSearchedData(userData);
    } else {
      var result = userData.filter((item) => {
        if (
          item.name
            .toString()
            .toLowerCase()
            .includes(searchBox.name.toLowerCase()) &&
          item.mobile
            .toString()
            .toLowerCase()
            .includes(searchBox.mobile.toLowerCase()) &&
          (searchBox.verified == "" || searchBox.verified == item.verify)
        ) {
          return item;
        }
      });
      setSearchedData(result);
    }
  }, [searchBox]);

  return (
    <Layout
      module="user"
      title="User's List (PFA/FA/FM)"
      breadcrumb="Home-User's List"
    >
      {showSpinner ? (
        <div class="spinner-border loader" role="status">
          <span class="sr-only"></span>
        </div>
      ) : (
        <>
          <div class="row">
            <div class="col-md-4">
              <div class="mb-4">
                <label for="" class="form-label">
                  Name
                </label>
                <input
                  type="text"
                  className="form-control"
                  maxLength={20}
                  onChange={(e) =>
                    setSearchBox({ ...searchBox, name: e.target.value })
                  }
                />
              </div>
            </div>
            <div class="col-md-4">
              <div class="mb-4">
                <label for="" class="form-label">
                  MSN
                </label>
                <input
                  type="number"
                  className="form-control"
                  onChange={(e) =>
                    setSearchBox({ ...searchBox, mobile: e.target.value })
                  }
                />
              </div>
            </div>
            <div class="col-md-4">
              <div class="mb-4">
                <label for="" class="form-label">
                  Verified
                </label>
                <select
                  onChange={(e) =>
                    setSearchBox({ ...searchBox, verified: e.target.value })
                  }
                  class="form-select"
                >
                  <option value={""}>All</option>
                  <option value={"Verified"}>Verified</option>
                  <option value={"Not Verified"}>Not Verified</option>
                </select>
              </div>
            </div>
          </div>
          <DataTableList columns={columns} lovedOneData={searchedData} />
        </>
      )}
    </Layout>
  );
}
export default UserList;
